import React, { forwardRef } from 'react';

import { Heading, HeadingProps } from '../Heading/Heading';

type ListLabelProps = Omit<
  HeadingProps<'li'>,
  'as' | 'size' | 'variant' | '__orbitStyleConfig'
>;

export const ListLabel = forwardRef<HTMLLIElement, ListLabelProps>(
  (props, ref) => {
    // @ts-expect-error Heading thinks this is an h2 so some props are
    // complaining. We can remove this warning once we figure out how to make
    // generic components with forwardRef
    return <Heading {...props} as="li" ref={ref} variant="title" />;
  },
);
